import request from '@/utils/request'
import { yyApi } from '@/utils/keyMap'
import { useUserStore, useDeviceStore } from '@/store/home'


// 获取当前文件的可用设备
export async function getEquipment(id, loginSource) {
  const deviceStore = useDeviceStore()
  const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
  let r = await request({
    url: `/wechat/home/seal/details/${id}`,
    method: 'GET',
    params: {
      version: 'v3.4.1',
      loginSource: loginSource || (userInfo.loginType === 18 ? 1 : undefined)
    }
  })
  if (r.success && r.data[0]) {
    deviceStore.secretSealProcess = r.data[0]['secretSealProcess'] == 1
  }
  return r
}

// 查看文件属性（是否可以开始用印）（1：不能用印（时间已超出）  2：可以用印需要指纹   3：可以用印不需要指纹）
export function checkDocumentType(id) {
  return request({
    url: `/wechat/home/document/type/${id}`,
    method: 'GET'
  })
}

// 用印时判断当前印章是否可以使用 1、可以使用 2、超出电子围栏 3、设备锁定
export async function fenceStatus(params) {
  const deviceStore = useDeviceStore()
  let r = await request({
    // url: `/wechat/home/document/seal/type/${params.documentId}/${params.sealId}`,
    url: `/wechat/home/seal/check/${params.documentId}/${params.sealId}`,
    method: 'GET'
  })
  if (r.success) {
    deviceStore.secretSealProcess = r.data['secretSealProcess'] == 1
  }
  return r
}
export function firmwareEdition(number) {
  //固件升级信息
  return request({
    url: `wechat/monitoring/firmware/edition?number=${number}`,
    method: 'GET'
  })
}

// 获取设备权限列表
export function getPermissions(number) {
  return request({
    url: `/wechat/permission/menu?number=` + number,
    method: 'GET'
  })
}

//设备锁定
export const remoteLock = (id) => {
  return request({
    url: `/wechat/monitoring/remoteLock/${id}`,
    method: 'GET'
  })
}

//设备解锁
export const remoteUnLock = (id) => {
  return request({
    url: `/wechat/monitoring/remoteUnLock/${id}`,
    method: 'GET'
  })
}

//获取当前设备影响开关状态
export const getImageType = (number) => {
  return request({
    url: `/wechat/video/getImageType/${number}`,
    method: 'GET'
  })
}

//修改设备影像管理
export const setImageType = (data) => {
  return request({
    url: '/wechat/video/updateImageType',
    method: 'PUT',
    data
  })
}
// 获取固件版本
export function getFirmwareEdition(params) {
  return request({
    url: '/firmware/upgrade',
    method: 'GET',
    params,
    show: false,
  })
}

// 获取A款指纹管理列表
export const getFingerprintShow = (params) => {
  return request({
    url: `/wechat/fingerprint/show`,
    method: 'GET',
    params
  })
}

// 删除对应指纹
export const deleteFingerprint = (data) => {
  return request({
    method: 'DELETE',
    url: '/wechat/fingerprint',
    data
  })
}

// 获取指纹录入列表页面数据
export const peopleList = (params) => {
  return request({
    url: '/wechat/details/staff/show',
    method: 'GET',
    params
  })
}

// 是否开启指纹录入
export const getFingerprint = (data) => {
  return request({
    method: 'PUT',
    url: '/wechat/fingerprint/V3.3.0',
    data
  })
}

//上传视频或者图片
export const uploadImage = (data) => {
  return request({
    url: '/file/upload',
    method: 'POST',
    data: data
  })
}

export const uploadImageOne = (data) => {
  return request({
    url: '/file/upload/one',
    method: 'POST',
    data: data
  })
}

// 远程盖印锁定设备
export const remotePrintLock = (number) => {
  return request({
    url: '/wechat/remote/lock/equipment?number=' + number,
    method: 'PUT'
  })
}

// 远程盖印解锁设备
export const remotePrintUnlock = (number, id) => {
  return request({
    url: `/wechat/remote/unlock/equipment?number=${number}&documentRemoteId=${id}`,
    method: 'PUT'
  })
}

// 发起远程确认
export function initiateRemotePrint(data) {
  return request({
    url: '/wechat/remote',
    method: 'POST',
    data
  })
}

//连续用印结束上传
export const continuousPrint = (data) => {
  const deviceStore = useDeviceStore()
  data = { busiTag: '全段', ...data, ...{ leftTimes: yyApi.leftTimes(deviceStore.device.number), operationId: yyApi.getDocumentLoginId() } }
  return request({
    url: '/wechat/video',
    method: 'POST',
    data
  })
}

//判断设备是否在使用中
export const equipment = (number) => {
  return request({
    url: `/wechat/monitoring/equipment/link/${number}`,
    method: 'GET'
  })
}

// 获取指纹录入列表页面数据新接口
export const getStaffShowNew = (params) => {
  return request({
    url: '/wechat/fingerprint/staff/show',
    method: 'GET',
    params
  })
}

//设备权限验证(是否为保管员，3.2.6用户与设备权限有变更)
export const whetherTrustee = ({ number, key }) => {
  return request({
    url: `wechat/monitoring/equipment/whetherTrustee/${number}/${key}`,
    method: 'GET'
  })
}

// OCR文件对比
export const ocrContrast = (data) => {
  return request({
    url: '/wechat/manage/ocr/v3.7.1',
    method: 'POST',
    data
  })
}

// 查询OCR是否过期
export const ocrInspect = (documentId) => {
  return request({
    url: `/wechat/home/ocr/check/${documentId}`,
    method: 'GET'
  })
}

// 切换印控仪模式
export const setPhotographType = (data) => {
  return request({
    url: `/wechat/monitoring/equipment/photograph`,
    method: 'PUT',
    data
  })
}
export const setWifiPriority = (data) => {
  return request({
    url: `wechat/wifi/priority`,
    method: 'PUT',
    data
  })
}

//设备操作埋点
export const buryingPoint = (params) => {
  console.log('埋点', params)
}

// 扫码登录验证
export const verLogin = (data) => {
  return request({
    url: `/wechat/qrCode/getDetail`,
    method: 'POST',
    data
  })
}

// 扫码登录验证
export const verLoginPC = (data) => {
  return request({
    url: `/common/qrCode?qrCode=${data.qrCode}`,
    method: 'POST',
    data
  })
}

//用印入口埋点
export const documentPoint = (data) => {
  return request({
    url: '/documentPoint/point',
    method: 'POST',
    data
  })
}

// 远程开机
export const getWakes = (id) => {
  return request({
    url: `/wechat/monitoring/wake/${id}`,
    method: 'get'
  })
}

// “一键寻印”获取位置
export const getAddress = (id) => {
  return request({
    url: `/wechat/monitoring/getAddress/${id}`,
    method: 'get'
  })
}

//二维码比对
export const qrcodeDiff = (data) => {
  return request({
    url: `/wechat/qrCode/diff`,
    method: 'POST',
    data
  })
}

// 获取ocr对比文件列表
export const getOcrFileList = (params) => {
  return request({
    url: `/wechat/ocr/file`,
    method: 'GET',
    params
  })
}
// 天玺拍摄视频发送盖印时间点
export const sendVideoCut = (data) => {
  return request({
    url: '/videoCut',
    method: 'POST',
    data
  })
}

// 发起ocr人工审核
export const ocrApproval = (data) => {
  return request({
    url: '/wechat/ocr/approval',
    method: 'POST',
    data
  })
}

//ocr人工审核-单页模式-机会扣减
export const ocrChanceReduce = (data) => {
  return request({
    url: '/wechat/ocr/chance/reduce',
    method: 'POST',
    data
  })
}

//OCR附件解析失败重新解析
export const ocrReAnalyze = (data) => {
  return request({
    url: '/wechat/ocr/ocrAnalysis',
    method: 'PUT',
    data
  })
}

//图片上传与矫正
export const imageCorrection = (params, onUploadProgress) => {
  return request({
    url: '/wechat/manage/imageCorrection',
    method: 'POST',
    params,
    onUploadProgress: onUploadProgress
  })
}

//获取环境配置下h5上传的 aplus最低版本号
export function getAplusEditionDown(params) {
  return request({
    url: `${process.env.newConnect ? 'https://apiv2.yda.cn' : process.env.VITE_API_BASE_URL}/wechat/personal/newConnect`,
    method: 'GET',
    params
  })
}
// app  用户指纹列表
export const getFingerUserList = (params) => {
  return request({
    url: '/photograph/fingerprint/show',
    method: 'GET',
    params
  })
}

// app指纹录入人员列表
export const getFingerprintShowApp = (params) => {
  return request({
    url: '/photograph/fingerprint/staff/show',
    method: 'GET',
    params
  })
}

// 点击人员 获取指纹position
export const getUserPosition = (data) => {
  return request({
    url: '/photograph/fingerprint/entering',
    method: 'PUT',
    data
  })
}

// 录入成功之后的状态返回云端
export const putErollState = (data) => {
  return request({
    url: '/photograph/fingerprint/entering/state',
    method: 'PUT',
    data
  })
}
// 高拍仪向云端请求数据导入本地指纹库
export const getUpdateFinger = (params) => {
  return request({
    url: '/photograph/fingerprint/import',
    method: 'GET',
    params
  })
}

// 高拍仪向云端发送指纹导入状态
export const putImportState = (data) => {
  return request({
    url: '/photograph/fingerprint/import/state',
    method: 'PUT',
    data
  })
}

// 根据设备编号获取高拍仪状态
export const getPhotographStatus = (params) => {
  return request({
    url: '/photograph/photograph/status',
    method: 'GET',
    params
  })
}
// 获取高拍仪更新状态
export const getPhotographMessage = (params) => {
  return request({
    url: '/photograph/message',
    method: 'GET',
    params
  })
}

// 视频打点上传
export const nodeVideoUpload = "/wechat/video/node/upload"

// 盖印后抓拍
export const afterPhotoApi = "/photograph/image/after/photo"

// 图片矫正上传
export const imgCorrectionApi = "/wechat/manage/imageCorrection"


// 设备详情
export const getEquipmentInfo = (params) => {
  return request({
    url: '/wechat/monitoring/equipment/show/info',
    method: 'GET',
    params
  })
}
// 用印预警消息上传
export const uploadSealWarning = (data) => {
  return request({
    url: '/wechat/stampdata/warning',
    method: 'POST',
    data
  })
}


// 获取ocr对比进度
export const getOcrProgressData = (params) => {
  return request({
    url: '/wechat/manage/ocr/progress',
    method: 'GET',
    params
  })
}

// 设备环境信息获取
export const getEquipmentEnv = (params) => {
  return request({
    url: '/wechat/equipment/personalUrl',
    method: 'GET',
    params
  })
}

// 裸章图片上传
export const uploadNakedSealImage = (data) => {
  return request({
    url: '/wechat/stampdata/nakedSeal/upload',
    method: 'POST',
    data
  })
}

export const uploadFirstSealImage = (data) => {
  return request({
    url: '/wechat/stampdata/firstSeal/upload',
    method: 'POST',
    data
  })
}





